import { BrowserRouter, Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import OnboardingPage from './pages/OnboardingPage'
import PricingPage from './pages/PricingPage'
import HardwarePage from './pages/HardwarePage'
import NotFoundPage from './pages/NotFoundPage'
import FeaturesHubPage from './pages/FeaturesHubPage'
import FeatureDetailPage from './pages/FeatureDetailPage'
import BusinessTypePage from './pages/BusinessTypePage'
import FaqPage from './pages/FaqPage'
import TermsPage from './pages/TermsPage'
import PrivacyPage from './pages/PrivacyPage'
import SeoContentPage from './pages/SeoContentPage'
import CardReadersHubPage from './pages/CardReadersHubPage'
import CardReaderDetailPage from './pages/CardReaderDetailPage'
import ComparePage from './pages/ComparePage'
import GuidesHubPage from './pages/GuidesHubPage'
import GuideDetailPage from './pages/GuideDetailPage'
import { businessTypes } from './content/businessTypes'
import { seoPages } from './content/seoPages'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/features" element={<FeaturesHubPage />} />
        <Route path="/features/:slug" element={<FeatureDetailPage />} />
        {businessTypes.map((b) => (
          <Route
            key={b.slug}
            path={b.path}
            element={<BusinessTypePage slug={b.slug} />}
          />
        ))}
        {seoPages.map((p) => (
          <Route
            key={p.slug}
            path={p.path}
            element={<SeoContentPage slug={p.slug} />}
          />
        ))}
        <Route path="/card-readers" element={<CardReadersHubPage />} />
        <Route path="/card-readers/:slug" element={<CardReaderDetailPage />} />
        <Route path="/compare/:slug" element={<ComparePage />} />
        <Route path="/guides" element={<GuidesHubPage />} />
        <Route path="/guides/:slug" element={<GuideDetailPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/hardware" element={<HardwarePage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
